import { createContext } from "react";

/** Keeps portals owned by a blocked control group out of pointer and keyboard navigation. */
export const InteractionBlockContext = createContext(false);
